import React, {useState, useEffect} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { useRegisterMutation } from '../../slices/students/studentsApiSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const StudentRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [register, { isLoading }] = useRegisterMutation();

  const { studentInfo } = useSelector((state) => state.authStudent);
  const { teacherInfo } = useSelector((state) => state.authTeacher);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get('redirect') || '/studentnewanswer';

  useEffect(() => {
    if (studentInfo) {
      navigate(redirect);
    }
  }, [navigate, studentInfo, redirect]);
    
  useEffect(() => {
    if (teacherInfo) {
      navigate('/teachernewquestions');
    }
  },[navigate, teacherInfo]); 

  const submitHandler = async (e) => {
    e.preventDefault()
    if (firstname == '') { toast.error('Please enter  first name'); return; } 
    if (lastname == '') { toast.error('Please enter  last name'); return; }
    if (email == '') { toast.error('Please enter  email'); return; }
    if (password == '') { toast.error('Please enter  password'); return; }    
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
    } else {
      try {
        const res = await register({ firstname, lastname, email, password }).unwrap();
        dispatch(setStudentCredentials({ ...res }));
        navigate(redirect);
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  }
  
  return (
    <div className="bg-default">
      <div className="main-content" >
        <div className=" mt--7 loginResponsive">
          <div className="header bg-gradient-primary py-6 py-lg-8 pt-lg-7">
            <div className="container-fluid">
              <div className="header-body text-center mb-7">
                <div className="row justify-content-center">
                  <div className="col-xl-5 col-lg-6 col-md-8 px-5">
                    <h1 className="text-white loginLogo2">
                      <img src="../../assets/img/log4.png" className="imgResponsive"  style={{ marginLeft: "1%", width: "12%"}}  />
                      <br /><a href="/teacherlogin" className="text-light loginLogo">Ask to Learn</a>
                    </h1>
                    <p className="text-lead text-white loginText">Student Register</p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="separator separator-bottom separator-skew zindex-100">
              <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <polygon className="fill-default" points="2560 0 2560 100 0 100"></polygon>
              </svg>
            </div> */}
          </div>
          <div className="container mt--9 pb--9 ">
            <div className="row justify-content-center ">
              <div className="col-lg-5 col-md-7 ">
                <div className="card border-0 mb-0 ">
                  {/* <div className="card-header bg-transparent pb-4">
                    <div className="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                    <div className="btn-wrapper text-center">
                      <a href="#" className="btn btn-neutral btn-icon">
                        <span className="btn-inner--icon"><img src="../../assets/img/icons/common/facebook.png" /></span>
                        <span className="btn-inner--text">Facebook</span>
                      </a>
                      <a href="#" className="btn btn-neutral btn-icon">
                        <span className="btn-inner--icon"><img src="../../assets/img/icons/common/google.svg" /></span>
                        <span className="btn-inner--text">Google</span>
                      </a>
                    </div>
                  </div> */}
                  <div className="card-body px-lg-5 py-lg-5">
                    <div className="text-center text-muted mb-4">
                      <small>Register with credentials</small>
                    </div>
                    <form role="form" onSubmit={submitHandler}>
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text"><i className="ni ni-hat-3"></i></span>
                          </div>
                          <input 
                            className="form-control emailForm" 
                            placeholder=" First Name" 
                            type="text" 
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}                        
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text"><i className="ni ni-hat-3"></i></span>
                          </div>
                          <input 
                            className="form-control emailForm" 
                            placeholder=" Last Name" 
                            type="text" 
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}                        
                          />
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text"><i className="ni ni-email-83"></i></span>
                          </div>
                          <input 
                            className="form-control emailForm" 
                            placeholder=" Email" 
                            type="email" 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text"><i className="ni ni-lock-circle-open"></i></span>
                          </div>
                          <input 
                            className="form-control emailForm" 
                            placeholder=" Password" 
                            type="password"  
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text"><i className="ni ni-lock-circle-open"></i></span>
                          </div>
                          <input 
                            className="form-control emailForm" 
                            placeholder=" Confirm Password" 
                            type="password"  
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="custom-control custom-control-alternative custom-checkbox">
                      <input className="custom-control-input" id=" customCheckLogin" type="checkbox" checked="check" />
                      <label className="custom-control-label" htmlFor=" customCheckLogin">
                          <span className="text-muted">Remember me</span>
                        </label>
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary my-4 border border-light rounded-pill">Sign in</button>
                      </div>
                      {isLoading && <Loader />}
                    </form>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-6">
                    <Link to={'/teacherlogin'} className="text-light">
                      <small>Teacher? Login here</small>
                    </Link>
                  </div>
                  <div className="col-6 text-right">
                    <Link to={'/studentlogin'} className="text-light">
                      <small>Student Login</small>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="py-5" id="footer-main">
          <div className="container">
            <div className="row align-items-center justify-content-xl-between">
              <div className="col-xl-6">
                <div className="copyright text-center text-xl-left text-muted">
                   <a  className="font-weight-bold ml-1 text-white" target="_blank">Ask to Learn</a>
                </div>
              </div>
              <div className="col-xl-6">
                <ul className="nav nav-footer justify-content-center justify-content-xl-end">
                  <li className="nav-item">
                    <a  className="nav-link text-white" target="_blank">Categories</a>
                  </li>
                  <li className="nav-item">
                    <a  className="nav-link text-white" target="_blank">About Us</a>
                  </li>
                  <li className="nav-item">
                    <a  className="nav-link text-white" target="_blank">Blog</a>
                  </li>
                  <li className="nav-item">
                    <a  className="nav-link text-white" target="_blank">License</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default StudentRegister